import { CameraControls } from '@react-three/drei'
import Butterfly from './components/Butterfly';
import World from './components/World';
import { useMediaQuery } from 'react-responsive'
import { useContext, useEffect, useRef } from 'react';
import { AppContext } from './providers/AppContext';
import { useFrame } from '@react-three/fiber';

import * as THREE from 'three'

const cameraStateValues = [
  {
    desktopPosition: [-5.3, 2.7, 3.2],
    desktopTarget: [0.3074947182196721, 0.72, 0.2918472946144027],
    mobilePosition: [-4.85, 3.33, 4.22],
    mobileTarget: [-0.011431438176874767, 0.8917167537103774, -0.16059589723201143],
  },
  {
    desktopPosition: [-2.445693053175936, 1.2595518078786994, -1.6985342183694492],
    desktopTarget: [-0.7597273909125617, 0.6811214404104058, -3.878113370899744],
    mobilePosition: [-2.445693053175936, 1.2595518078786994, -1.6985342183694492],
    mobileTarget: [-0.7597273909125617, 0.6811214404104058, -3.878113370899744],
  },
  {
    desktopPosition: [0.05460617684095781, 1.5181527399877135, -1.2296907738497276],
    desktopTarget: [1.7367904497647375, 0.807241451301499, -3.3726999660912735],
    mobilePosition: [0.05460617684095781, 1.5181527399877135, -1.2296907738497276],
    mobileTarget: [1.7367904497647375, 0.807241451301499, -3.3726999660912735],
  },
  {
    desktopPosition: [0.7210973729387127, 1.4698839429908892, 2.711561583427847],
    desktopTarget: [3.3511493635186014, 0.7588250675428333, 2.001034322178373],
    mobilePosition: [0.7210973729387127, 1.4698839429908892, 2.711561583427847],
    mobileTarget: [3.3511493635186014, 0.7588250675428333, 2.001034322178373],
  },
  {
    desktopPosition: [-0.0071251783240984246, 1.3291048056027601, 3.6099200573953483],
    desktopTarget: [2.7134869339004024, 0.7316832755718123, 4.020997223823001],
    mobilePosition: [-0.0071251783240984246, 1.3291048056027601, 3.6099200573953483],
    mobileTarget: [2.7134869339004024, 0.7316832755718123, 4.020997223823001],
  },
]

export default function Experience() {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const { cameraState } = useContext(AppContext);

    const cameraControlsRef = useRef();
    const butterflyRef = useRef();

    useEffect(() => {
      if (!cameraControlsRef.current) return;
      if (isMobile) {
        cameraControlsRef.current.setTarget(-0.011431438176874767, 0.8917167537103774, -0.16059589723201143)
      } else {
        cameraControlsRef.current.setTarget(0.3074947182196721, 0.72, 0.2918472946144027)
      }
    }, [cameraControlsRef.current])

    useEffect(() => {
      if (!cameraControlsRef.current) return;

      if (cameraState < 5) {
        const positionValues = isMobile
          ? cameraStateValues[cameraState].mobilePosition
          : cameraStateValues[cameraState].desktopPosition;

        const targetValues = isMobile
          ? cameraStateValues[cameraState].mobileTarget
          : cameraStateValues[cameraState].desktopTarget;

        cameraControlsRef.current.setLookAt(
          positionValues[0],
          positionValues[1],
          positionValues[2],
          targetValues[0],
          targetValues[1],
          targetValues[2],
          true
        );
      }
    }, [cameraState, isMobile]);

    useFrame(() => {
      if (
        !cameraControlsRef.current ||
        !butterflyRef.current ||
        cameraState !== 5
      )
        return;

      const pos = butterflyRef.current.position;
      const offset = new THREE.Vector3(-2.5, 1, 0);
      const cameraPos = pos.clone().add(offset);

      cameraControlsRef.current.setLookAt(
        cameraPos.x,
        cameraPos.y,
        cameraPos.z,
        pos.x,
        pos.y,
        pos.z,
        false
      );
    });

    return (
        <>
            <CameraControls
                ref={cameraControlsRef}
                target={isMobile ? [-0.011431438176874767, 0.8917167537103774, -0.16059589723201143] : [0.3074947182196721, 0.72, 0.2918472946144027]}
                enableDamping
                enablePan={false}
                minPolarAngle={0}
                maxPolarAngle={Math.PI / 2}
                maxDistance={cameraState === 0 ? 7 : 3}
                minDistance={1}  
            />

            <color
                args={["#316897"]}
                attach="background"
            />

            <ambientLight intensity={1} />

            <World />
            <Butterfly ref={butterflyRef} />
        </>
    )
}